import api, { ApiResponse } from "../api";
import {
  FreightListRequest,
  FreightListResponse,
  LinehaulOutboundPlanningSummary,
  LinehaulOutboundPlanningSummaryRequest,
} from "./models";

class LinehaulOutboundPlanningService {
  private static instance: LinehaulOutboundPlanningService;

  private constructor() {}

  static getInstance(): LinehaulOutboundPlanningService {
    if (!LinehaulOutboundPlanningService.instance) {
      LinehaulOutboundPlanningService.instance = new LinehaulOutboundPlanningService();
    }
    return LinehaulOutboundPlanningService.instance;
  }

  public getInHouseFreightSummary = async (
    requestData: LinehaulOutboundPlanningSummaryRequest
  ): Promise<ApiResponse<LinehaulOutboundPlanningSummary[]>> => {
    return await api.get("/linehaul/outbound-planning/in-house-freight/summary", {
      params: requestData,
    });
  };

  public getInboundFreightSummary = async (
    requestData: LinehaulOutboundPlanningSummaryRequest
  ): Promise<ApiResponse<LinehaulOutboundPlanningSummary[]>> => {
    return await api.get("/linehaul/outbound-planning/inbound-freight/summary", {
      params: requestData,
    });
  };

  public getInHouseFreightList = async (
    requestData: FreightListRequest
  ): Promise<ApiResponse<FreightListResponse>> => {
    return await api.get("/linehaul/outbound-planning/in-house-freight/list", {
      params: {
        originTerminalNumber: requestData.originTerminalNumber,
        destinationTerminalNumbers: requestData.destinationTerminalNumbers.join(","),
      },
    });
  };

  public getInboundFreightList = async (
    requestData: FreightListRequest
  ): Promise<ApiResponse<FreightListResponse>> => {
    return await api.get("/linehaul/outbound-planning/inbound-freight/list", {
      params: {
        originTerminalNumber: requestData.originTerminalNumber,
        destinationTerminalNumbers: requestData.destinationTerminalNumbers.join(","),
      },
    });
  };
}

export default LinehaulOutboundPlanningService;
